module.exports = __webpack_public_path__ + "img/view-enhanced.952d4507.jpg";